import { render, staticRenderFns } from "./answerDetail.vue?vue&type=template&id=0f3b7f16&scoped=true"
import script from "./answerDetail.vue?vue&type=script&lang=js"
export * from "./answerDetail.vue?vue&type=script&lang=js"
import style0 from "./answerDetail.vue?vue&type=style&index=0&id=0f3b7f16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3b7f16",
  null
  
)

export default component.exports